import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlightDistrutto'
})
export class HighlightDistruttoPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(value: string): SafeHtml | string {
    if (value && (distruttoRegex.test(value) || declassificatoRegex.test(value) || versatoRegex.test(value))) {
      return this.sanitizer.bypassSecurityTrustHtml(`<span style="color:red">${value}</span>`);
    } else {
      return value;
    }
  }
}

export const distruttoRegex = /(distrutto .*? del \d{2}\/\d{2}\/\d{4})/i;
export const declassificatoRegex = /(Declassificato a .*?)/i;
export const versatoRegex = /(versato agli archivi di stato .*?)/i;
